export const SadSmileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="188"
    height="187"
    viewBox="0 0 188 187"
    fill="none"
  >
    <path
      d="M66.25 139.75C74.1125 133.923 83.6862 130.5 94 130.5C104.314 130.5 113.887 133.923 121.75 139.75"
      stroke="#969696"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M121.75 93.5001C126.859 93.5001 131 87.288 131 79.6251C131 71.9621 126.859 65.7501 121.75 65.7501C116.641 65.7501 112.5 71.9621 112.5 79.6251C112.5 87.288 116.641 93.5001 121.75 93.5001Z"
      fill="#969696"
    />
    <path
      d="M66.25 93.5001C71.3586 93.5001 75.5 87.288 75.5 79.6251C75.5 71.9621 71.3586 65.7501 66.25 65.7501C61.1414 65.7501 57 71.9621 57 79.6251C57 87.288 61.1414 93.5001 66.25 93.5001Z"
      fill="#969696"
    />
    <path
      d="M186.5 93.5C186.5 137.105 186.5 158.907 172.949 172.449C159.416 186 137.605 186 94 186C50.3955 186 28.5933 186 15.042 172.449C1.5 158.916 1.5 137.105 1.5 93.5C1.5 49.8955 1.5 28.0933 15.042 14.542C28.6025 1 50.3955 1 94 1C137.605 1 159.407 1 172.949 14.542C181.958 23.5515 184.974 36.2147 185.991 56.5"
      stroke="#969696"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
